<div class="absolute top-0 left-0 w-full h-full bg-white text-center px-3 py-4" style="z-index: 9999">
  <button mat-icon-button (click)="closeMobileMenu()">
    <fa-icon [icon]="faXmark" />
  </button>

  @if ((appState$ | async)?.session) {
    <div (click)="closeMobileMenu()" class="mt-3">
      <app-navbar align="center" />
    </div>
  }

  <div class="mt-3 text-center">
    <div class="inline-block">
      <app-user-menu />
    </div>
  </div>
</div>
